package space.resolvingcode.tableNavigator

import kotlinx.browser.*
import kotlinx.html.*
import kotlinx.html.dom.*
import kotlinx.html.js.*

fun main() {
    document.body!!.append.run {
        div("container-xl my-2 position-relative") {
            h1 {
                +"項目・分類による表検索システム / Variable-based Table Navigator"
            }
            p("pb-4") {
                a("https://www.e-stat.go.jp/", target = ATarget.blank) { +"e-Stat 政府統計の総合窓口" }
                +"で公開されている統計表を、項目と分類の組み合わせから選ぶことができます。"
            }

            div("") {
                h2 { +"調査を選んでください" }
                div("row") {
                    div("col-4") {
                        div("my-2 text-center border border-secondary rounded") {
                            style = "height: 350px;overflow-y: auto;"
                            div("pt-2 w-75 btn-group-vertical") {
                                id = "surveyList"
                            }
                        }
                        div {
                            button(classes = "mt-2 btn btn-primary") {
                                id = "surveyBtn"
                                +"選択"
                                onClickFunction = { selectSurvey() }
                            }
                        }
                    }
                    div("col-2") {
                        div("my-2 text-center border border-secondary rounded") {
                            div("btn-group-vertical") {
                                id = "surveyYear"
                            }
                        }
                    }
                    div("col-6 my-2 rounded bg-dark-subtle") {
                        id = "surveyInfo"
                        style = "height: 380px;overflow-y: auto;"
                    }
                }
            }

            div("my-4") {
                style = "min-height: 300px;"
                h2("py-2") {
                    style = "border-top: 2px solid #465;"
                    +"表示したい値を選びましょう（表章項目）"
                }
                div("mb-4") {
                    id = "itemList"
                }
                div {
                    button(classes = "invisible") {
                        id = "itemBtn"
                        +"選択"
                        onClickFunction = { selectItem() }
                    }
                }
            }

            div("my-4") {
                h2("py-2") {
                    style = "border-top: 2px solid #465;"
                    +"分類に使う項目を1つ以上選びましょう"
                }
                p{ +"※一部の組み合わせは選択できません" }
                div("row py-4") {
                    div("col-9") {
                        div("mb-2") {
                            id = "grpList"
                        }
                        div {
                            button(classes = "btn btn-primary") {
                                +"選択"
                                onClickFunction = { selectGrp() }
                            }
                        }
                    }
                    div("col-3") {
                        label("form-label") { +"分類の内容例（表によって異なる場合があります）" }
                        ul("list-group rounded bg-dark-subtle") {
                            style = "height: 400px;"
                            id = "grpEnums"
                        }
                    }
                }
            }

            div("my-4") {
                style = "min-height: 80px;"
                div("mb-2") {
                    label("form-label") { +"選択した分類" }
                    span("mx-4 p-2 fw-bold bg-dark-subtle") {
                        //style = "background-color:#243;"
                        id = "itemNameMirror"
                        +"表章項目："
                    }
                }
                div("d-flex flex-wrap gap-2") {
                    id = "grpBadges"
                }
            }

            div("pb-4") {
                style = "max-height: 1000px;overflow-y: auto;"
                h2("py-2") {
                    style = "border-top: 2px solid #465;"
                    +"選択した分類に対応する統計表はこちら"
                }
                div {
                    id = "tables"
                }

            }
            div("z-1 ps-2 pb-3 position-absolute start-0 bottom-0 opacity-75 text-light rounded invisible") {
                style = "min-height: 100px; width: 85%; background-color: #336;"
                id = "releaseNote"
                span("badge") {
                    button(classes = "btn-close") {
                        onClickFunction = {
                            document.getElementById("releaseNote")!!.apply {
                                className = className.replace("visible", "invisible")
                            }
                        }
                    }
                }
            }
        }

        footer("") {
            div("container-xl border-top") {
                div("row py-2 text-body-secondary") {
                    div("col") {
                        div {
                            button(classes = "btn btn-info") {
                                +latestVer
                                onClickFunction = {
                                    document.getElementById("releaseNote")!!.apply {
                                        className = className.replace("invisible", "visible")
                                    }
                                }
                            }
                            span("px-2 align-middle") {
                                id = "update"
                            }
                        }
                        div {
                            +"Created by "
                            a("https://github.com/ichiromurata", target = ATarget.blank) { +"Ichiro MURATA" }
                        }
                    }
                    div("col text-end") {
                        div {
                            +"Styled with "
                            a("https://getbootstrap.com/", target = ATarget.blank) { +"Bootstrap CSS" }
                            +" and "
                        }
                        div {
                            a("https://bootswatch.com/", target = ATarget.blank) { +"Bootswatch theme" }
                        }
                    }
                }
            }
        }
    }
    addThemeEvent()
    loadSurveys()
    putReleaseNote()
}

